/** True for a path-absolute internal target ("/merch/CODE"), rejecting scheme, protocol-relative ("//") and backslash ("/\\") URLs. */
export const isSafeInternalPath = (value: unknown): value is string => {
	if (typeof value !== "string" || value.length === 0) {
		return false;
	}

	if (!value.startsWith("/")) {
		return false;
	}

	if (value.startsWith("//") || value.startsWith("/\\")) {
		return false;
	}

	return true;
};
